module.exports = __webpack_public_path__ + "KaTeX_Main-Italic.5a09c2d1.ttf";